import React from 'react';
import { Link, useParams } from 'react-router-dom';
import productData from '../data/productData';
import './ProductCategoryPage.css';

const ProductCategoryPage = () => {
  const { category } = useParams();
  const key = (category || '').toLowerCase();
  const categoryData = productData[key];

  if (!categoryData) {
    return (
      <div className="pc-page">
        <section className="pc-hero">
          <div className="pc-hero-overlay" />
          <div className="pc-hero-content">
            <h1>Category Not Found</h1>
            <p>The requested category is not available in our current catalog.</p>
          </div>
        </section>

        <div className="pc-container">
          <div className="pc-empty">
            <p>Please choose a valid category from Products menu.</p>
            <Link to="/products" className="pc-back-link">Back to Products</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-page">
      <section className="pc-hero">
        <div className="pc-hero-overlay" />
        <div className="pc-hero-content">
          <h1>{categoryData.name}</h1>
          <p>Explore our curated hybrid varieties for consistent field performance.</p>
        </div>
      </section>

      <div className="pc-container">
        <div className="pc-grid">
          {categoryData.varieties.map((variety) => (
            <article key={variety.id} className="pc-card">
              <h3>{variety.name}</h3>
              <p>{variety.description}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductCategoryPage;
